import { render, staticRenderFns } from "./standardChecklist.vue?vue&type=template&id=4b4e51d2"
import script from "./standardChecklist.vue?vue&type=script&lang=js"
export * from "./standardChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports